import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { ShowMoreButton, ShowMoreButtonContainer } from "../../homePage.styles";
import { Section, SectionTitle } from "components/section";
import { NewsContainer } from "./news.styles";
import { New, NewDescription, NewImage, NewTheme, NewTitle } from "components/new";
import { useHomeState } from "pages/home/context/home-context";
import { useHomeController } from "pages/home/context/home-controller";
import { useAppState } from "main/context/app-context";
import { ACTION_TYPES, useHomeDispatch } from "pages/home/context/home-context";


export const NewsSection = () => {
  const navigate = useNavigate();
  const { news } = useHomeState();
  const { listNews } = useHomeController();
  const { homeData } = useAppState();
  const homeDispatch = useHomeDispatch();

  useEffect(() => {
    (async () => {
      // Se os dados já foram carregados no AppState, usa eles
      if (homeData?.news && !news) {
        homeDispatch({
          type: ACTION_TYPES.setNews,
          payload: homeData.news,
        });
      } else if (!news && !homeData?.news) {
        // Só carrega se não existir nem no AppState nem no HomeState
        await listNews(4);
      }
    })();

  }, [homeData?.news, news]);

  return (
      <Section background="gray">
        <SectionTitle>Notícias</SectionTitle>
        <NewsContainer>
          {news?.items.map((item) => (
            <New key={item.id} onClick={() => navigate(`/noticias/${item.id}`)}>
              <NewImage src={item.imageUrl} alt={item.title} />
              <NewTheme>{item.category}</NewTheme>
              <NewTitle>{item.title}</NewTitle>
              <NewDescription>{item.subtitle}</NewDescription>
            </New>
          ))}
        </NewsContainer>
        <ShowMoreButtonContainer>
          <ShowMoreButton onClick={() => navigate("/noticias")}>
            Todas as notícias
          </ShowMoreButton>
        </ShowMoreButtonContainer>
      </Section>
  );
};
